import { setSearchTerm } from "../warehousesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useWhsSearch = () =>
  useSearch((s) => s.data.listing.warehouses.searchTerm, setSearchTerm);
